import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import dictionaryHEB from "../i18n/HE_dictionary.json";
import dictionaryENG from "../i18n/EN_dictionary.json";
import i18nextBrowserLanguagedetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: dictionaryENG,
  },
  he: {
    translation: dictionaryHEB,
  },
};

i18n
  .use(initReactI18next)
  .use(i18nextBrowserLanguagedetector)
  .init({
    resources,
    react: {
      useSuspense: false,
    },
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
